import React from "react"

const TangramProject = () => (
  <svg
    width="62"
    height="123"
    viewBox="0 0 62 123"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M45.8438 106.551L44.7402 105.447L45.4473 104.74L45.8438 105.136L46.2402 104.74L46.9473 105.447L45.8438 106.551ZM42.4473 101.74L43.9473 103.24L43.2402 103.947L41.7402 102.447L42.4473 101.74ZM39.4473 98.7399L40.9473 100.24L40.2402 100.947L38.7402 99.447L39.4473 98.7399ZM36.4473 95.7399L37.9473 97.2399L37.2402 97.947L35.7402 96.447L36.4473 95.7399ZM33.4473 92.7399L34.9473 94.2399L34.2402 94.947L32.7402 93.447L33.4473 92.7399ZM31.1974 90.4899L31.9474 91.2399L31.2402 91.947L30.4902 91.197L31.1974 90.4899ZM47.7402 103.24L49.2402 101.74L49.9473 102.447L48.4473 103.947L47.7402 103.24ZM50.7402 100.24L52.2402 98.7399L52.9473 99.447L51.4473 100.947L50.7402 100.24ZM53.7402 97.2399L55.2402 95.7399L55.9473 96.447L54.4473 97.947L53.7402 97.2399ZM56.7402 94.2399L58.2402 92.7399L58.9473 93.447L57.4473 94.947L56.7402 94.2399ZM60.1366 90.8435L59.7402 91.2399L60.4473 91.947L61.5508 90.8435L60.4473 89.7399L59.7402 90.447L60.1366 90.8435ZM58.2402 88.947L56.7402 87.447L57.4473 86.7399L58.9473 88.2399L58.2402 88.947ZM55.2402 85.947L53.7402 84.447L54.4473 83.7399L55.9473 85.2399L55.2402 85.947ZM52.2402 82.9471L50.7402 81.4471L51.4473 80.7399L52.9473 82.2399L52.2402 82.9471ZM49.2402 79.9471L47.7402 78.4471L48.4473 77.74L49.9473 79.24L49.2402 79.9471ZM46.2402 76.9471L45.4902 76.1971L46.1973 75.49L46.9473 76.24L46.2402 76.9471Z"
      fill="#AFB2C6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M58.2133 92.7122L56.7133 94.2122L57.4204 94.9193L58.9204 93.4193L58.2133 92.7122ZM61.3168 96.1728L61.3168 94.03L60.3168 94.03L60.3168 96.1728L61.3168 96.1728ZM55.2133 95.7121L53.7133 97.2121L54.4204 97.9193L55.9204 96.4193L55.2133 95.7121ZM61.3168 100.459L61.3168 98.3157L60.3168 98.3157L60.3168 100.459L61.3168 100.459ZM52.2133 98.7121L50.7133 100.212L51.4204 100.919L52.9204 99.4192L52.2133 98.7121ZM49.2133 101.712L47.7133 103.212L48.4204 103.919L49.9204 102.419L49.2133 101.712ZM61.3168 104.744L61.3168 102.601L60.3168 102.601L60.3168 104.744L61.3168 104.744ZM61.3168 109.03L61.3168 106.887L60.3168 106.887L60.3168 109.03L61.3168 109.03ZM47.7133 108.419L49.2133 109.919L49.9204 109.212L48.4204 107.712L47.7133 108.419ZM50.7133 111.419L52.2133 112.919L52.9204 112.212L51.4204 110.712L50.7133 111.419ZM61.3168 113.316L61.3168 111.173L60.3168 111.173L60.3168 113.316L61.3168 113.316ZM53.7133 114.419L55.2133 115.919L55.9204 115.212L54.4204 113.712L53.7133 114.419ZM61.3168 117.601L61.3168 115.459L60.3168 115.459L60.3168 117.601L61.3168 117.601ZM56.7133 117.419L58.2133 118.919L58.9204 118.212L57.4204 116.712L56.7133 117.419ZM59.7133 120.419L61.3168 122.023L61.3168 119.744L60.4525 119.744L60.4204 119.712L60.3883 119.744L60.3168 119.744L60.3168 119.816L59.7133 120.419Z"
      fill="#AFB2C6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.565 17.656L42.2014 19.0197L42.9085 19.7268L44.2721 18.3631L43.565 17.656ZM40.6069 16.4641H42.7497V15.4641H40.6069V16.4641ZM40.8377 20.3833L39.4741 21.7469L40.1812 22.454L41.5448 21.0904L40.8377 20.3833ZM38.1105 23.1106L36.7468 24.4742L37.4539 25.1813L38.8176 23.8177L38.1105 23.1106ZM36.3212 16.4641H38.464V15.4641H36.3212V16.4641ZM35.3832 25.8378L34.0196 27.2014L34.7267 27.9086L36.0903 26.5449L35.3832 25.8378ZM32.0355 16.4641H34.1783V15.4641H32.0355V16.4641ZM32.6559 28.5651L31.2923 29.9287L31.9994 30.6358L33.363 29.2722L32.6559 28.5651ZM29.9287 31.2923L28.565 32.656L29.2721 33.3631L30.6358 31.9995L29.9287 31.2923ZM27.7498 16.4641H29.8926V15.4641H27.7498V16.4641ZM27.2014 34.0196L25.8378 35.3832L26.5449 36.0903L27.9085 34.7267L27.2014 34.0196ZM23.4641 16.4641H25.6069V15.4641H23.4641V16.4641ZM24.4741 36.7469L23.1105 38.1105L23.8176 38.8176L25.1812 37.454L24.4741 36.7469ZM21.7469 39.4741L20.3832 40.8378L21.0903 41.5449L22.454 40.1812L21.7469 39.4741ZM19.1784 16.4641H21.3212V15.4641H19.1784V16.4641ZM19.0196 42.2014L17.656 43.565L18.3631 44.2721L19.7267 42.9085L19.0196 42.2014ZM16.4641 45.1004L16.9995 45.6358L15.4641 47.1711V44.8926H16.4641V45.1004ZM16.4641 42.7498V40.6069H15.4641V42.7498H16.4641ZM16.4641 38.4641V36.3212H15.4641V38.4641H16.4641ZM16.4641 34.1784V32.0355H15.4641V34.1784H16.4641ZM16.4641 29.8927V27.7498L15.4641 27.7498V29.8927L16.4641 29.8927ZM16.4641 25.607V23.4641L15.4641 23.4641V25.607L16.4641 25.607ZM16.4641 21.3213V19.1784L15.4641 19.1784V21.3213L16.4641 21.3213Z"
      fill="#AFB2C6"
    />
    <path
      d="M0.5 92.0715H1.5V91.2072L2.10355 90.6037L1.39644 89.8966L0.5 90.793L0.5 92.0715Z"
      fill="#AFB2C6"
    />
    <path d="M1.5 96.3572L1.5 94.2144H0.5L0.5 96.3572H1.5Z" fill="#AFB2C6" />
    <path d="M1.5 100.643V98.5001H0.5L0.5 100.643H1.5Z" fill="#AFB2C6" />
    <path d="M1.5 104.929L1.5 102.786H0.5L0.5 104.929H1.5Z" fill="#AFB2C6" />
    <path d="M1.5 109.214L1.5 107.072H0.5L0.5 109.214H1.5Z" fill="#AFB2C6" />
    <path d="M1.5 113.5V111.357H0.5L0.5 113.5H1.5Z" fill="#AFB2C6" />
    <path d="M1.5 117.786L1.5 115.643H0.5L0.5 117.786H1.5Z" fill="#AFB2C6" />
    <path
      d="M1.5 120V119.929H1.42857L1.39644 119.896L1.36432 119.929H0.5L0.5 122.207L2.10355 120.604L1.5 120Z"
      fill="#AFB2C6"
    />
    <path
      d="M3.60355 89.1037L5.10354 87.6037L4.39643 86.8966L2.89644 88.3966L3.60355 89.1037Z"
      fill="#AFB2C6"
    />
    <path
      d="M4.39644 116.896L2.89644 118.396L3.60355 119.104L5.10354 117.604L4.39644 116.896Z"
      fill="#AFB2C6"
    />
    <path
      d="M6.60354 86.1037L8.10353 84.6037L7.39643 83.8966L5.89643 85.3966L6.60354 86.1037Z"
      fill="#AFB2C6"
    />
    <path
      d="M7.39643 113.896L5.89643 115.396L6.60354 116.104L8.10353 114.604L7.39643 113.896Z"
      fill="#AFB2C6"
    />
    <path
      d="M9.60353 83.1037L11.1035 81.6037L10.3964 80.8966L8.89642 82.3966L9.60353 83.1037Z"
      fill="#AFB2C6"
    />
    <path
      d="M10.3964 110.897L8.89642 112.397L9.60353 113.104L11.1035 111.604L10.3964 110.897Z"
      fill="#AFB2C6"
    />
    <path
      d="M12.6035 80.1037L14.1035 78.6037L13.3964 77.8966L11.8964 79.3966L12.6035 80.1037Z"
      fill="#AFB2C6"
    />
    <path
      d="M13.3964 107.897L11.8964 109.397L12.6035 110.104L14.1035 108.604L13.3964 107.897Z"
      fill="#AFB2C6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47.2069 16.5L45.6034 14.8964L44.9998 15.5L44.9284 15.5714L44.9284 15.5898L44.9284 15.6357L44.9284 16.5L47.2069 16.5ZM44.1034 13.3965L42.6034 11.8965L41.8963 12.6036L43.3963 14.1036L44.1034 13.3965ZM40.6427 16.5L42.7856 16.5L42.7856 15.5L40.6427 15.5L40.6427 16.5ZM41.1034 10.3965L39.6034 8.89647L38.8963 9.60357L40.3963 11.1036L41.1034 10.3965ZM36.357 16.5L38.4999 16.5L38.4999 15.5L36.357 15.5L36.357 16.5ZM38.1034 7.39647L36.6034 5.89648L35.8963 6.60358L37.3963 8.10358L38.1034 7.39647ZM35.1034 4.39648L33.6034 2.89648L32.8963 3.60359L34.3963 5.10359L35.1034 4.39648ZM32.0713 16.5L34.2142 16.5L34.2142 15.5L32.0713 15.5L32.0713 16.5ZM32.1034 1.39649L30.9999 0.292938L29.8963 1.39649L30.6034 2.10359L30.9999 1.70715L31.3963 2.1036L32.1034 1.39649ZM27.7856 16.5L29.9285 16.5L29.9285 15.5L27.7856 15.5L27.7856 16.5ZM28.3963 2.89648L26.8963 4.39648L27.6034 5.10359L29.1034 3.60359L28.3963 2.89648ZM25.3963 5.89647L23.8963 7.39647L24.6035 8.10358L26.1034 6.60358L25.3963 5.89647ZM23.4999 16.5L25.6427 16.5L25.6427 15.5L23.4999 15.5L23.4999 16.5ZM22.3963 8.89647L20.8964 10.3965L21.6035 11.1036L23.1035 9.60357L22.3963 8.89647ZM19.2142 16.5L21.357 16.5L21.357 15.5L19.2142 15.5L19.2142 16.5ZM19.3964 11.8965L17.8964 13.3965L18.6035 14.1036L20.1035 12.6036L19.3964 11.8965ZM16.3964 14.8964L14.7928 16.5L17.0713 16.5L17.0713 15.6357L17.0713 15.5937L17.0713 15.5714L17 15.5L16.3964 14.8964Z"
      fill="#AFB2C6"
    />
    <path
      d="M16.5 106L16.5 105L16.5 104.944L16.3328 104.944L16.2969 104.944L16.2386 104.944L15.4458 104.944L15.4458 107.151L16.5 106Z"
      fill="#AFB2C6"
    />
    <path
      d="M18.3448 104.252L19.7084 102.889L19.0013 102.182L17.6377 103.545L18.3448 104.252Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.4458 100.944L15.4458 102.944L16.4458 102.944L16.4458 100.944L15.4458 100.944Z"
      fill="#AFB2C6"
    />
    <path
      d="M21.072 101.525L22.4357 100.162L21.7286 99.4545L20.3649 100.818L21.072 101.525Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.4458 96.9444L15.4458 98.9444L16.4458 98.9444L16.4458 96.9444L15.4458 96.9444Z"
      fill="#AFB2C6"
    />
    <path
      d="M23.7993 98.798L25.1629 97.4343L24.4558 96.7272L23.0922 98.0908L23.7993 98.798Z"
      fill="#AFB2C6"
    />
    <path
      d="M26.5266 96.0707L27.8902 94.7071L27.1831 94L25.8194 95.3636L26.5266 96.0707Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.4458 92.9444L15.4458 94.9444L16.4458 94.9444L16.4458 92.9444L15.4458 92.9444Z"
      fill="#AFB2C6"
    />
    <path
      d="M29.2538 93.3434L30.6175 91.9798L29.9103 91.2727L28.5467 92.6363L29.2538 93.3434Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.4458 88.9444L15.4458 90.9444L16.4458 90.9444L16.4458 88.9444L15.4458 88.9444Z"
      fill="#AFB2C6"
    />
    <path
      d="M31.9811 90.6162L33.3447 89.2525L32.6376 88.5454L31.274 89.9091L31.9811 90.6162Z"
      fill="#AFB2C6"
    />
    <path
      d="M34.7083 87.8889L36.072 86.5253L35.3649 85.8182L34.0012 87.1818L34.7083 87.8889Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.4458 84.9444L15.4458 86.9444L16.4458 86.9444L16.4458 84.9444L15.4458 84.9444Z"
      fill="#AFB2C6"
    />
    <path
      d="M37.4356 85.1616L38.7992 83.798L38.0921 83.0909L36.7285 84.4545L37.4356 85.1616Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.4458 80.9445L15.4458 82.9444L16.4458 82.9444L16.4458 80.9445L15.4458 80.9445Z"
      fill="#AFB2C6"
    />
    <path
      d="M40.1629 82.4344L41.5265 81.0707L40.8194 80.3636L39.4558 81.7273L40.1629 82.4344Z"
      fill="#AFB2C6"
    />
    <path
      d="M42.8901 79.7071L44.2538 78.3435L43.5467 77.6364L42.183 79L42.8901 79.7071Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.4458 76.9445L15.4458 78.9445L16.4458 78.9445L16.4458 76.9445L15.4458 76.9445Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.4458 72.9445L15.4458 74.9445L16.4458 74.9445L16.4458 72.9445L15.4458 72.9445Z"
      fill="#AFB2C6"
    />
    <path
      d="M44.2538 73.5455L42.8901 72.1818L42.183 72.8889L43.5467 74.2526L44.2538 73.5455Z"
      fill="#AFB2C6"
    />
    <path
      d="M41.5265 70.8182L40.1629 69.4546L39.4558 70.1617L40.8194 71.5253L41.5265 70.8182Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.4458 68.9445L15.4458 70.9445L16.4458 70.9445L16.4458 68.9445L15.4458 68.9445Z"
      fill="#AFB2C6"
    />
    <path
      d="M38.7992 68.0909L37.4356 66.7273L36.7285 67.4344L38.0921 68.798L38.7992 68.0909Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.4458 64.9445L15.4458 66.9445L16.4458 66.9445L16.4458 64.9445L15.4458 64.9445Z"
      fill="#AFB2C6"
    />
    <path
      d="M36.072 65.3637L34.7083 64L34.0012 64.7071L35.3649 66.0708L36.072 65.3637Z"
      fill="#AFB2C6"
    />
    <path
      d="M33.3447 62.6364L31.9811 61.2728L31.274 61.9799L32.6376 63.3435L33.3447 62.6364Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.4458 60.9445L15.4458 62.9445L16.4458 62.9445L16.4458 60.9445L15.4458 60.9445Z"
      fill="#AFB2C6"
    />
    <path
      d="M30.6174 59.9091L29.2538 58.5455L28.5467 59.2526L29.9103 60.6162L30.6174 59.9091Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.4458 56.9445L15.4458 58.9445L16.4458 58.9445L16.4458 56.9445L15.4458 56.9445Z"
      fill="#AFB2C6"
    />
    <path
      d="M27.8902 57.1819L26.5265 55.8182L25.8194 56.5254L27.1831 57.889L27.8902 57.1819Z"
      fill="#AFB2C6"
    />
    <path
      d="M25.1629 54.4546L23.7993 53.091L23.0922 53.7981L24.4558 55.1617L25.1629 54.4546Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.4458 52.9446L15.4458 54.9445L16.4458 54.9445L16.4458 52.9446L15.4458 52.9446Z"
      fill="#AFB2C6"
    />
    <path
      d="M22.4357 51.7274L21.072 50.3637L20.3649 51.0708L21.7285 52.4345L22.4357 51.7274Z"
      fill="#AFB2C6"
    />
    <path
      d="M15.4458 48.9446L15.4458 50.9446L16.4458 50.9446L16.4458 48.9446L15.4458 48.9446Z"
      fill="#AFB2C6"
    />
    <path
      d="M19.7084 49.0001L18.3448 47.6365L17.6377 48.3436L19.0013 49.7072L19.7084 49.0001Z"
      fill="#AFB2C6"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.5456 74.2531L42.182 72.8894L42.8891 72.1823L44.2527 73.5459L43.5456 74.2531ZM46.4446 70.945V72.945H45.4446V70.945H46.4446ZM40.8183 71.5258L39.4547 70.1622L40.1618 69.455L41.5254 70.8187L40.8183 71.5258ZM46.4446 66.945V68.945H45.4446V66.945H46.4446ZM38.0911 68.7985L36.7274 67.4349L37.4345 66.7278L38.7982 68.0914L38.0911 68.7985ZM35.3638 66.0713L34.0002 64.7076L34.7073 64.0005L36.0709 65.3642L35.3638 66.0713ZM46.4446 62.945V64.945H45.4446V62.945H46.4446ZM32.6365 63.344L31.2729 61.9804L31.98 61.2733L33.3436 62.6369L32.6365 63.344ZM46.4446 58.945V60.945H45.4446V58.945H46.4446ZM29.9093 60.6167L28.5456 59.2531L29.2527 58.546L30.6164 59.9096L29.9093 60.6167ZM27.182 57.8895L25.8184 56.5258L26.5255 55.8187L27.8891 57.1824L27.182 57.8895ZM46.4446 54.945V56.945H45.4446V54.945H46.4446ZM24.4547 55.1622L23.0911 53.7986L23.7982 53.0915L25.1618 54.4551L24.4547 55.1622ZM46.4446 50.945V52.945H45.4446V50.945H46.4446ZM21.7275 52.4349L20.3638 51.0713L21.071 50.3642L22.4346 51.7278L21.7275 52.4349ZM19.0002 49.7077L17.6366 48.344L18.3437 47.6369L19.7073 49.0006L19.0002 49.7077ZM46.4446 46.945V48.945H45.4446V46.945H46.4446ZM46.4446 42.945V44.945H45.4446V42.945H46.4446ZM17.6366 43.546L19.0002 42.1824L19.7073 42.8895L18.3437 44.2531L17.6366 43.546ZM20.3638 40.8188L21.7275 39.4551L22.4346 40.1622L21.071 41.5259L20.3638 40.8188ZM46.4446 38.9451V40.9451H45.4446V38.9451H46.4446ZM23.0911 38.0915L24.4547 36.7279L25.1619 37.435L23.7982 38.7986L23.0911 38.0915ZM46.4446 34.9451V36.9451H45.4446V34.9451H46.4446ZM25.8184 35.3642L27.182 34.0006L27.8891 34.7077L26.5255 36.0713L25.8184 35.3642ZM28.5456 32.637L29.9093 31.2733L30.6164 31.9805L29.2527 33.3441L28.5456 32.637ZM46.4446 30.9451V32.9451H45.4446V30.9451H46.4446ZM31.2729 29.9097L32.6365 28.5461L33.3436 29.2532L31.98 30.6168L31.2729 29.9097ZM46.4446 26.9451V28.9451H45.4446V26.9451H46.4446ZM34.0002 27.1824L35.3638 25.8188L36.0709 26.5259L34.7073 27.8896L34.0002 27.1824ZM36.7274 24.4552L38.0911 23.0916L38.7982 23.7987L37.4345 25.1623L36.7274 24.4552ZM46.4446 22.9451V24.9451H45.4446V22.9451H46.4446ZM39.4547 21.7279L40.8183 20.3643L41.5254 21.0714L40.1618 22.435L39.4547 21.7279ZM46.4446 18.9451V20.9451H45.4446V18.9451H46.4446ZM42.182 19.0007L43.5456 17.637L44.2527 18.3441L42.8891 19.7078L42.182 19.0007Z"
      fill="#AFB2C6"
    />
  </svg>
)

export default TangramProject
